module.exports = __webpack_public_path__ + "assets/img/pdf.f736fd28.svg";